import ApiClient from './apiClient'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getLink = async (): Promise<any> => ApiClient.get(
  '/api/link/view',
  (result) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postFreeeLink = async (code: string): Promise<any> => ApiClient.post(
  '/api/link/freee_link',
  (result) => result,
  { code: code },
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchFreeeLink = async (): Promise<any> => ApiClient.patch(
  '/api/link/freee_link',
  () => {
    // do nothing
  },
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deleteFreeeLink = async (): Promise<any> => ApiClient.delete(
  '/api/link/freee_link',
  () => {
    // do nothing
  },
)
